<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="float-end mb-1">
          <!-- <button type="button" class="btn btn-primary" @click="goToInsert">TEST</button> -->
          <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode"
            v-model="rProcCode" @change="changeProcCode()">
            <option :value="noVal" disabled>진행상태선택</option>
            <option value="A" >전체보기</option>
            <option :value="rProcCode.procCode" :key=i v-for="(rProcCode,i) in rProc">{{rProcCode.procName}}</option>
          </select>
        </div>
        <table class="table table-bordered table-striped fs-6">
          <thead class = "small">
            <tr>
              <th>상태</th>
              <th>구분</th>
              <th>신청일</th>
              <th>제목</th>
              <!-- <th>문의자</th>
              <th>이메일</th>
              <th>연락처</th> -->
              <th>응대자</th>
            </tr>
          </thead>
          <tbody class = "small">
            <tr :key="i" v-for="(rList, i) in reqList">
              <td>{{ rList.status }}</td>
              <td>{{ rList.cat }}</td>
              <td>{{ getDateFormat(rList.insDate) }}</td>
              <td class="text-primary"><a @click="goToRequestDetail(rList.seqReq);" style="cursor:pointer;">{{ rList.reqTitle }}</a></td>
              <!-- <td>{{ rList.reqPersonName }}</td>
              <td>{{ rList.reqEmail }}</td>
              <td>{{ rList.reqTel }}</td> -->
              <td>{{ rList.handlerNameKor }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      reqList: [],
      rProc: []
    };
  },
  created() {
    this.bSeq = this.$route.query.bSeq;
    // console.log("userInfo:",this.$store.state.user);
    // console.log("userInfo:",this.$store.state.user.email,"alimCall:", this.$store.state.user.alimCallC);
    // console.log("userInfoAA:",this.user.email,"alimCallAA:", this.user.alimCallC);

    if (this.$store.state.user.handlerId != undefined) {
      this.user = this.$store.state.user.handlerId
    }
    else if (this.$store.state.user.email != undefined) {
      this.user = this.$store.state.user.email
    }
    else {
      this.user = ""
    }    
    this.getReqProcLevel();
    this.getRequestList();

    //to do: 화면 회전
    // document.getElementById("your-button-id").addEventListener("click", function() {
    // screen.orientation.lock('landscape');
    // });

  },
  // filters: {
  //   currency: function(val) {
  //     var num = new Number(val);
  //     return num.toFixed(0).replacereplace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  // },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    // this.$swal.fire(
    // {
    //   position: 'top-start',
    //   icon: 'info',
    //   html: '<font color="red">가로보기</font>로 하시면<br>조금 더 편하게 이용하실 수 있습니다.',
    //   toast: true,
    //   showConfirmButton: false,
    //   timer: 1000
    // })
        
    if (screen.width < 768) 
    {
        window.innerWidth = screen.height;
        window.innerHeight = screen.width;
        window.screen.orientation.lock('landscape');
    }
        
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //비회원 접근 시 대응처리
    if(!this.$store.state.user.email || this.$store.state.user.email == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 후 이용해주세요.',
        icon: 'warning'
      });
      this.$router.push({path: '/'});
    }    
    // //권한없는 로그인 차단
    // if(this.user.handlerGrade >= 20) {
    //   var swal = require('sweetalert2');
    //   swal.fire({
    //     title: '로그인 필요',
    //     text: '접근권한 확인불가.',
    //     icon: 'error'
    //   });
    //   this.$router.push({path: '/'});
    // }
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    async getReqProcLevel() {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }
      //console.log("rProc:",this.rProc);
    },
    async getRequestList() {
      let reqList = await this.$api("/api/requestList_client", {param: [this.user.email]});
      if(reqList.length > 0) {
        this.reqList = reqList;
      }
      console.log("reqList:",this.reqList);
    },
    goToRequestDetail(seqReq) {
      this.$router.push({path: '/inquiryDetail_client', query: {seqReq: seqReq}});
      //console.log("oId:", orderId);
    },
    async changeProcCode() {
      if(this.rProcCode === 'A') {
        this.getRequestList();
      }
      else {
        let reqList_tmp = await this.$api("/api/requestList_client", {param: [this.user.email]})
        console.log("reqList_tmp:",reqList_tmp);
        this.reqList = reqList_tmp.filter(e => {return e.reqStatus === this.rProcCode});
      }
    }
  }
}
</script>